import { render, staticRenderFns } from "./TargetMarketSection.vue?vue&type=template&id=4e0191de"
import script from "./TargetMarketSection.vue?vue&type=script&lang=js"
export * from "./TargetMarketSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports